import { useTranslation } from "react-i18next";

const CircularProgressbar = ({ insideStrokeColor, outsideStrokeColor, strokeWidth, actualValue, totalValue,totalText }) => {
    const { t } = useTranslation();
    const radius = (50 - strokeWidth / 2);
    const pathDescription = `
      M 50,50 m 0,-${radius}
      a ${radius},${radius} 0 1 1 0,${2 * radius}
      a ${radius},${radius} 0 1 1 0,-${2 * radius}
    `;

    const diameter = Math.PI * 2 * radius;
    const getPercentage = () => {
        return (actualValue * 100) / totalValue;
    }
    const progressStyle: any = {
        stroke: outsideStrokeColor,
        // strokeLinecap: 'butt',
        strokeDasharray: `${diameter}px ${diameter}px`,
        strokeDashoffset: `${((100 - getPercentage()) / 100 * diameter)}px`,
    };

    return (
        <svg
            className={'CircularProgressbar'}
            viewBox="0 0 100 100"
            width={130}
            height={130}
        >
            <path
                className="CircularProgressbar-trail"
                d={pathDescription}
                strokeWidth={strokeWidth}
                fillOpacity={0}
                style={{
                    stroke: insideStrokeColor,
                }}
            />

            <path
                className="CircularProgressbar-path"
                d={pathDescription}
                strokeWidth={strokeWidth}
                fillOpacity={0}
                style={progressStyle}
            />

            <text
                className="CircularProgressbar-text"
                x={50}
                y={50}
                style={{
                    fill: insideStrokeColor,
                    fontSize: '20px',
                    fontWeight: 'bold',
                    dominantBaseline: 'initial',
                    textAnchor: 'middle',
                   // alignmentBaseline: 'after-edge',
                }}
            >
                {actualValue}
            </text>
            <text
                className="CircularProgressbar-text"
                x={50}
                y={50}
                style={{
                    fill: '#737373',
                    fontSize: '10px',
                    dominantBaseline: 'text-before-edge',
                    textAnchor: 'middle',
                    // alignmentBaseline: 'mathematical',
                    // marginTop:'20rem'
                }}
            >/{totalValue}</text>
            <text
                className="CircularProgressbar-text"
                x={50}
                y={60}
                style={{
                    fill: '#737373',
                    fontSize: '10px',
                    dominantBaseline: 'text-before-edge',
                    textAnchor: 'middle',
                    // alignmentBaseline: 'hanging',                    
                }}
            >{totalText? t("specialDayOffAdmin.sdoAdminReportStats.total") : t("specialDayOffAdmin.sdoAdminReportStats.requests")}</text>
        </svg>
    );
};

export default CircularProgressbar;